import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
// utility types:

/**
 * Wraps Object.keys with proper typescript definition of the resulting array
 */
export function keysOf(obj) {
  return Object.keys(obj);
}